import Vue from "vue";
import Component from "vue-class-component";
import Ribbon from "@/core/ribbon/ribbon.vue";
import JhiFooter from "@/core/jhi-footer/jhi-footer.vue";
import JhiNavbar from "@/core/jhi-navbar/jhi-navbar.vue";

import "@/shared/config/dayjs";
import TcgNavbar from "@/custom/navbar/tcgnavbar.vue";
import { Prop, Provide } from "vue-property-decorator";
import UserComposeService from "@/custom/service/user-compose.service";
import ProvinceService from "@/entities/province/province.service";

@Component({
  components: {
    ribbon: Ribbon,
    'jhi-navbar': JhiNavbar,

    'jhi-footer': JhiFooter,
    TcgNavbar: TcgNavbar,
  },
})
export default class App extends Vue {
  userAdminData = {
    users: [],
    // roles: [],
    loading: false,
    reload: () => this.getUsers(),
  };
  @Provide() userAdminDataFn = () => this.userAdminData; // example of reactive in provide/inject

  provincesObj = {
    provinces: [],
    loading: false,
  };
  @Provide() provincesFn = () => this.provincesObj;

  async fetchProvinces() {
    this.provincesObj.loading = true;
    const provinceService = new ProvinceService();
    const provincesRS = await provinceService.retrieve({ size: 70 });

    this.provincesObj.provinces = provincesRS?.data || [];
    this.provincesObj.loading = false;
  }

  @Prop() mobileMode: boolean;

  mounted() {
    if (!this.$route.path.startsWith('/mobile/')) {
      this.getUsers();
      this.fetchProvinces();
    }
  }

  async getUsers() {
    this.userAdminData.loading = true;
    const userComposeService = new UserComposeService();
    try {
      const usersRS = await userComposeService.retrieveUser();
      const userMap = {};
      usersRS.forEach(e => (userMap[e.id] = e));

      this.userAdminData.users = usersRS;
      this.userAdminData.loading = false;
    } catch (e) {
      console.log(e);
      this.userAdminData.loading = false;
    }
  }
}
